import { PageRequestsForInvoicing } from "@components/modules/invoices/for-invoicing/listing/PageRequestsForInvoicing";
import { NavigationFinance } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`For invoicing`} navigation={<NavigationFinance />}>
    <DemoModule module={Modules.InvoicesForInvoicing}>
      <PageRequestsForInvoicing />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/invoices/for-invoicing/")({
  component: Page,
});
